import React from "react";
import * as Icons from "lucide-react";
import { whyUs } from "../../mock";

const WhyUs = () => {
  return (
    <section className="py-20 lg:py-28 bg-slate-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.08]" style={{ backgroundImage: "radial-gradient(rgba(255,255,255,0.6) 1px, transparent 1px)", backgroundSize: "22px 22px" }} />
      <div className="absolute -top-40 right-0 h-96 w-96 rounded-full bg-teal-500/10 blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-6">
        <div className="max-w-2xl">
          <div className="text-[12px] uppercase tracking-[0.22em] font-semibold text-teal-300">Why Manish Labchem</div>
          <h2 className="mt-3 font-display font-extrabold text-white text-[34px] lg:text-[46px] leading-[1.08]">
            Six reasons procurement heads <span className="text-teal-300">stay with us</span>
          </h2>
          <p className="mt-4 text-slate-300 text-[16px] leading-relaxed">
            Reliability is not a marketing word for us — it is contractually measured. Below is what our key accounts consistently rate us on.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {whyUs.map((w) => {
            const Icon = Icons[w.icon] || Icons.Star;
            return (
              <div key={w.title} className="group p-6 rounded-2xl bg-white/[0.04] border border-white/10 hover:bg-white/[0.07] hover:border-teal-400/40 transition-colors">
                <div className="h-12 w-12 rounded-xl bg-teal-500/15 border border-teal-400/30 flex items-center justify-center">
                  <Icon className="h-6 w-6 text-teal-300" />
                </div>
                <h3 className="mt-5 font-display font-bold text-[19px] text-white">{w.title}</h3>
                <p className="mt-2 text-[14px] text-slate-300 leading-relaxed">{w.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
